/*
Sohel 01/22/2023 2789725780 Added Preprocessor Group Screen
Sohel 01/23/2023 2698964415 payload changes
Sohel 01/23/2023 3075154998 payload changes
Sohel 01/23/2023 3075154998 reset Toast message issue
Suresh Peddavoora  01/31/2023 3075154998 Fixed Spacing issues for Buttons
Dilip 02/01/2023 3075154998 code and description label changes
Sohel 01/02/2023 2698964415 unSaved popup changes
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Ravi 02/08/2023 3075154998 fixed unsaved popup issue
Rohini 02/09/2023 3075154998 added classnames for buttons
Akhila 04/10/2023 3075154998 unsaved changes bug fixed
Akhila 06/12/2023 3075154998 added role access
Sohel 06/16/2023 2698964415 Changed Fields API in Action and Condition
Ravi 06/19/2023 3075154998 Added Breadcrum in popup
Ravi 06/23/2023 3075154998 fixed submit issue
*/
import React, {useEffect, useState, useRef} from 'react';
import {Button} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import reusableInputStyles from '../../../../../components/InputStyles';
import {useSelector, useDispatch} from 'react-redux';
// import {
//   postAddProcessorGroup,
//   resetAddPreProcessor,
//   fetchAddProcessorGroup,
//   fetchSelectedProcessorFieldsData,
//   fetchPrePreprocessorGroupData,
// } from "../../../../../redux/reducers/DataManagerRecord";
import {fetchFieldsData} from '../../../../../redux/reducers/DataManagerRecord';
import {resetBasicInfo} from '../../../../../redux/reducers/DataManagerRecordGroup';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PreprocessorGroupStatic from '../../DataManagerRecord/AddDataManagerRecord/PreprocessorGroupStatic';
import BreadCrums from '../../../../../util/BreadCrum';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import AddProcessorGroup from '../../DataManagerRecord/AddDataManagerRecord/DMRAddPreProcessorGroup';
import SearchProcessorGroup from '../../DataManagerRecord/AddDataManagerRecord/DMRSearchPreProcessorsGroup';
import {
  resetAddProcessorGroup,
  postAddProcessorGroup,
  fetchPreprocessorGroupData,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const PreprocessorGroup = ({
  handleBack,
  setValue,
  exportManagerRecord,
  handleDirty,
  hidden,
  showAlertRef,
  managerRecordGroup = false,
  exportRecordGroupAccess,
  editExisting,
  importRecordGroupAccess,
}) => {
  const classes = reusableInputStyles();
  const [showSearch, setShowSearch] = useState(false);
  const [processorGroupCode, setProcessorGroupCode] = useState('');
  const dispatch = useDispatch();
  const saveRef = useRef();
  const showAlert = useRef(false);
  const {prepProcessorGroupData} = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const [dmProcessorGroupId,setDmProcessorGroupId] =useState(0);
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  const {
    isLoading,
    successMsg,
    errorMsg,
    addPreprocessorGroupStatus,
    groupCode,
    basicInfoData,
    processorGroupData,
    dmRecordGroupId,
  } = useSelector(({ dataManagerRecordGroup }) => dataManagerRecordGroup);
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [errorMsg, successMsg]);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const handleSubmit = () => {
    if (groupCode) {
      dispatch(submissionStart());
      const payload = {
        dmProcessorRecordGroupMapId: processorGroupData?.dmProcessorRecordGroupMapId
          ? processorGroupData?.dmProcessorRecordGroupMapId
          : 0,
        isDraft: 'N',
        processorGroupCode: processorGroupCode,
        recordGroupCode: groupCode,
        fileType: type,
        lastStep: 3,
        processorGroupId: dmProcessorGroupId ? dmProcessorGroupId :0,
        recordGroupId: dmRecordGroupId ? dmRecordGroupId : 0,
      };
      dispatch(postAddProcessorGroup(payload));
    }
  };
  useEffect(() => {
    if (processorGroupData?.processorGroupCode && !showSearch) {
      setProcessorGroupCode(
        processorGroupCode ? processorGroupCode : processorGroupData?.processorGroupCode,
      );
    }
  }, [processorGroupData, showSearch]);
  useEffect(()=>{
    if(prepProcessorGroupData?.dmProcessorGroupId){
      setDmProcessorGroupId(dmProcessorGroupId ? dmProcessorGroupId : prepProcessorGroupData?.dmProcessorGroupId)
    }
  },[prepProcessorGroupData])
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        if (addPreprocessorGroupStatus === 200) {
          dispatch(resetAddProcessorGroup());
        }
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addPreprocessorGroupStatus === 200 && successMsg) {
      setTimeout(() => {
        if (!saveRef.current) {
          setValue(0);
        }
        dispatch(resetAddProcessorGroup());
      }, 1500);
    }
  }, [addPreprocessorGroupStatus, successMsg]);
  useEffect(() => {
    if (dmRecordGroupId) {
      dispatch(fetchPreprocessorGroupData(dmRecordGroupId));
    }
  }, [dmRecordGroupId]);
  useEffect(() => {
    if (dmRecordGroupId) {
      dispatch(fetchFieldsData(type, dmRecordGroupId, managerRecordGroup));
    }
  }, [dmRecordGroupId]);
  useEffect(() => {
    handleDirty(processorGroupData?.processorGroupCode !== processorGroupCode);
  }, [processorGroupCode]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  return showSearch ? (
    <div className="new-standard-textfields">
      <Button
        variant="text"
        className={'mb-2 search-btn'}
        onClick={() => {
          if (showAlertRef.current) {
            dispatch(
              setAlertData({
                showAlert: showAlertRef.current,
                alertCallback: () => {
                  setShowSearch(false);
                },
              }),
            );
          } else {
            setShowSearch(false);
          }
        }}
      >
        <ArrowBack className="mr-2" />
        Go Back
      </Button>
      <div>
        <BreadCrums
          name={`${type} Record Group Name`}
          code={basicInfoData?.groupCode}
          description={`${type} Record Group Description`}
          descriptionValue={basicInfoData?.groupDescription}
          returnType={'Type'}
          returnTypeValue={basicInfoData?.groupType || ''}
        />
      </div>
      <AddProcessorGroup
        setShowSearch={setShowSearch}
        setProcessorGroupCode={setProcessorGroupCode}
        exportManagerRecord={exportManagerRecord}
        handleDirty={handleDirty}
        showAlert={showAlert}
        showAlertRef={showAlertRef}
        managerRecordGroup={managerRecordGroup}
        exportRecordGroupAccess={exportRecordGroupAccess}
        importRecordGroupAccess={importRecordGroupAccess}
        editExisting={editExisting}
      />
    </div>
  ) : (
    <>
      <div>
        <BreadCrums
          name={`${type} Record Group Name`}
          code={basicInfoData?.groupCode}
          description={`${type} Record Group Description`}
          descriptionValue={basicInfoData?.groupDescription}
          returnType={'Type'}
          returnTypeValue={basicInfoData?.groupType || ''}
        />
      </div>
      <SearchProcessorGroup
        setShowSearch={setShowSearch}
        setProcessorGroupCode={setProcessorGroupCode}
        processorGroupCode={processorGroupCode}
        exportManagerRecord={exportManagerRecord}
        managerRecordGroup={managerRecordGroup}
        handleDirty={handleDirty}
        setDmProcessorGroupId={setDmProcessorGroupId}
      />
      {processorGroupCode && (
        <>
          <PreprocessorGroupStatic prepProcessorGroupData={prepProcessorGroupData} />
        </>
      )}
      <div className="d-flex justify-content-center new-standard-textfields mt-3">
        <Button
          variant="outlined"
          onClick={() => {
            handleBack();
          }}
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
        >
          Back
        </Button>
        {/* {isDraftRecordGroup === "N" && ( */}
        <Button
          variant="outlined"
          disabled={
            (editExisting === 'Export Record Group' && !exportRecordGroupAccess?.edit) ||
              (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) || enabledSubmission
          }
          onClick={() => {
            handleSubmit();
            saveRef.current = true;
            handleDirty(false, 'fixed');
          }}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
        >
            Save
        </Button>
        {/* )} */}
        <Button
          variant="outlined"
          disabled={
            !processorGroupCode ||
            (editExisting === 'Export Record Group' && !exportRecordGroupAccess?.edit) ||
            (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) || enabledSubmission
          }
          onClick={() => {
            handleSubmit();
            saveRef.current = false;
          }}
          className={`search-btn mx-1 ${classes.buttonRoot}`}
        >
          Finish
        </Button>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </>
  );
};

export default PreprocessorGroup;
